module.exports = __webpack_public_path__ + "img/upcoming-fixtures-4.55170e8c.svg";